export const CARE_ADVOCATE_PHONE = "(855) 360-1317"
export const CARE_ADVOCATE_PHONE_LINK = `[${CARE_ADVOCATE_PHONE}](tel:8553601317)`

// just an identifier, not a secret
export const PENDO_AGENT_ID = "c6bauLVXSUYWmTSZcLlkaVG6lig"
